import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PlantillasComponent } from './platillas/plantillas.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { AgregarPlantillaComponent } from './agregar-plantilla/agregar-plantilla.component';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment.dev';
import { AdministradorDePlantillasService } from './administrador-de-plantillas.service';
import { Plantilla, PlantillasResponse } from '../../models/plantillas.model';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'administrador-de-plantillas',
    templateUrl: 'administrador-de-plantillas.component.html',
    imports:[
        CommonModule,
        MatIconModule,
        MatSidenavModule,
        MatButtonModule,

        PlantillasComponent,
        HasPermissionsDirective,
    ]
})

export class AdministradorDePlantillasComponent implements OnInit {
    @ViewChild('drawer') drawer: MatDrawer;
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;
    panels: any[] = [];
    selectedPanel: number;
    seccionId: number;
    //paginacion de plantillas
    inicio:number = 0
    max:number = 10

    seccionPrehispanica:number= environment.TIPOLOGIA_ID_SECCION_PREHISPANICA
    seccionHispanicaRepublicana:number = environment.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA
    seccionBienesInmuebles:number= environment.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    plantillas$: Observable<PlantillasResponse>


    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private administradorDePlantillasService: AdministradorDePlantillasService
    ) {
        this.plantillas$= this.administradorDePlantillasService.plantillas$
    }

    ngOnInit() { 
        this.route.queryParams.subscribe(params => {
            const seccion = params['seccion'];
            this.seccionId = Number(seccion);
        });

        this.goToPanel(this.seccionPrehispanica)

        this.panels = [
            {
                id: this.seccionPrehispanica,
                icon: 'heroicons_outline:map',
                title: 'Prehispánica',
                description:
                    'Agregue o remplace las plantillas utilizadas para la seccion Prehispánica',
            },
            {
                id: this.seccionHispanicaRepublicana,
                icon: 'heroicons_outline:scale',
                title: 'Hispanica Republicana',
                description:
                    'Agregue o remplace las plantillas utilizadas para la seccion Hispanica Republicana',
            },
            {
                id: this.seccionBienesInmuebles,
                icon: 'heroicons_outline:building-library',
                title: 'Bienes Inmuebles',
                description:
                    'Agregue o remplace las plantillas utilizadas para la seccion Bienes Inmuebles',
            },
        ];

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Set the drawerMode and drawerOpened
                if (matchingAliases.includes('lg')) {
                    this.drawerMode = 'side';
                    this.drawerOpened = true;
                } else {
                    this.drawerMode = 'over';
                    this.drawerOpened = false;
                }

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

    }

      ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    goToPanel(panel: number): void {
        this.selectedPanel = panel;

        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { seccion: panel },
            queryParamsHandling: 'merge', // conserva otros queryParams si hay
        });

        this.getListadoPlantillas(this.selectedPanel)

        // Close the drawer on 'over' mode
        if (this.drawerMode === 'over') {
            this.drawer.close();
        }
    }

    getPanelInfo(id: number): any {
        return this.panels.find((panel) => panel.id === id);
    }


    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    agregarPlantilla(){
        const dialog = this.dialog.open(AgregarPlantillaComponent, {
                    panelClass: ['w-full', 'md:w-6/12','mx-0'],
                    maxHeight: 'calc(100vh - 4rem)',
                    disableClose: true,
                })
        }

    getListadoPlantillas(seccionId:number){
        this.administradorDePlantillasService.getPlantillas(seccionId, this.inicio, this.max)
    }   

}